import { Attribute, Component, component, property } from '../../../concepts/objects';

const voteDef = {
    name: 'Vote',
};

@component(voteDef)
export class Vote extends Component {

    @property({ type: 'string', default: 'default' })
    public round!: string;

    @property({ type: 'string' })
    public userId!: string;
}

export const VoteAggregateAttr = new Attribute<number>('voteAggregateAttr');
export const VoteCountAttr = new Attribute<number>('voteCount');
export const VoteRankAttr = new Attribute<number>('voteRank');
